import { Component, Shark } from "shark-mvc";
import { Modal } from "bootstrap";

import templateContent from "./organization-add-panel.html";

import OrganizationMembership from "../../models/OrganizationMembership";
import Organization from "../../models/Organization";
import organizationView from "../../views/organization/organizationView";

class OrganizationAddPanelComponent extends Component {
	constructor () {
		super("organizationAddPanelComponent");

		this.addTemplate("", templateContent);
	}

	addOrganization () {
		// console.log("cdsaver");
		const { currUser, currUserOrganizationMembershipList, organizationList } = Shark.get();

		const currOrganization = new Organization({
			guid: Shark.__generateGUID(),
			// name: Shark.$store.labels.name_new_organization,
			ownerGuid: currUser.guid,
			status: 1,
		});

		organizationList.push(currOrganization);

		let currOrganizationMembership = new OrganizationMembership({
			guid: Shark.__generateGUID(),
			inviteEMail: currUser.email,
			inviteMessage: "",
			organizationGuid: currOrganization.guid,
			role: OrganizationMembership.ROLE_OWNER,
			status: OrganizationMembership.STATUS_ACTIVE,
			userGuid: currUser.guid,
		});
		
		currOrganizationMembership.__organizationName = currOrganization.name;
		
		// currUserOrganizationMembershipList.unshift(currOrganizationMembership);
		// console.log(currUserOrganizationMembershipList);

		Shark.set({
			currOrganization,
			currOrganizationMembership,
			currUserOrganizationMembershipList,
			editingOrganization: currOrganization,
			organizationList,
		});

		// document.querySelector(`[data-guid="`+ currOrganizationMembership.guid +`"]`).click();
		// this.enableEdits();
		this.open();	
	}

	addOrganizationBtn_clickHandler () {
		this.addOrganization();
	}

	afterLoad () {
		const modalNode = document.querySelector("#organizationAddModal");
		
		if (modalNode) {
			this.modal = new Modal(modalNode);
		}

		if (Shark.$store.__firstOrganizationToAdd) {
			this.addOrganization();
		}
	}

	cancelOrganizationAddBtn_clickHandler () {
		this.close();
	}

	close () {
		if (this.modal) {
			this.modal.hide();
		}
	}
	
	open () {
		if (this.modal) {
			this.modal.show();
			// Dave: Questo serve per ora, non togliere!
			Shark.render();
		}
	}

	async saveOrganizationBtn_clickHandler () {
		await organizationView.saveOrganization();
		this.close();
	}
}

const organizationAddPanelComponent = new OrganizationAddPanelComponent();

Shark.registerComponent(organizationAddPanelComponent);

export default organizationAddPanelComponent;